import styled from 'styled-components';
import { ReactComponent as MilestoneTodoIcon } from 'assets/svgs/milestone.svg';
import { ProductiveHeading07, BodyShort01 } from 'components/styles';

export const MilestoneIcon = styled(MilestoneTodoIcon)`
  fill: var(--black-100);
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-04);
`;

export const TitleMain = styled.p`
  ${ProductiveHeading07};
  font-weight: var(--font-weight-bold);
  margin-bottom: 0;
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

export const Title = styled.p<{ isResponsive: boolean }>`
  ${ProductiveHeading07};
  font-weight: var(--font-weight-bold);
  margin-bottom: 0;
  display: flex;
  flex-direction: ${({ isResponsive }) => (isResponsive ? 'column' : 'row')};
  align-items: ${({ isResponsive }) => (isResponsive ? 'start' : 'center')};
  justify-content: start;
  flex-grow: 1;
`;

export const ResourceText = styled.span`
  margin-right: var(--spacing-02);
  /* To make the status update email layout not to break */
  /* This won't effect the normal design as content is fixed */
  white-space: nowrap;
`;
export const StatusIcon = styled.span`
  margin-right: var(--spacing-03);
  display: flex;
  align-items: center;
`;
export const RangeInfo = styled.span`
  ${BodyShort01};
  color: var(--cool-gray-70);
  font-weight: var(--font-weight-normal);
  text-transform: initial;
  margin-left: var(--spacing-02);
  flex-grow: 1;
`;
